export const contentModel = {
  addons: [],
  item: "",
  quantity: 0,
  price: 0
};
